module.exports = __webpack_public_path__ + "img/social-habits.168f42d8.svg";